import styled from "styled-components";

import { TextField as DefaultTextField } from "@material-ui/core";

import { COLORS } from "constants/colorScheme";

export const TextField = styled(DefaultTextField)`
  &&& .MuiFormControl-root {
    background-color: ${COLORS.BLACK_4};
  }

  && {
    .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
      border-color: ${COLORS.RED};
    }
  }
`;
